<mat-progress-bar
  mode="query"
  *ngIf="loader.pipedLoadingState$ | async"
></mat-progress-bar>
<div *ngIf="!isMobileHeader" class="header">
  <a [routerLink]="'/'" class="header__logo">
    <img
      src="../../../../../assets/img/logo-text.svg"
      class="header__logo"
      alt="Lingon"
    />
  </a>
  <div class="header__credits" *ngIf="user && !isPreviewPage">
    <a [routerLink]="'/profile/credits'">
      <div class="ling-credits-logo"></div>
      <span class="header__credits__amount">{{ credits }} </span>
      <span class="header__credits__text">
        {{ handlePluralTranslation(credits, "creditName") | translate }}
      </span>
    </a>
  </div>
  <ul *ngIf="!isPreviewPage" class="header__nav">
    <ng-container *ngIf="user; else login">
      <ng-container *ngFor="let item of headerMenuItems">
        <li
          *ngIf="item.linkRoute !== 'profile'"
          class="header__nav__item"
          [class.header__nav__item_active]="isMenuItemActive(item)"
        >
          <a [routerLink]="item.linkRoute">
            <span *ngIf="!item.icon">
              {{ item.text! | translate }}
            </span>
            <img
              *ngIf="item.icon"
              class="icon"
              src="../../../../../assets/img/gear.svg"
              alt="gear icon"
            />
          </a>
        </li>
      </ng-container>
      <li
        class="header__nav__item header__nav__settings"
        #desktopSettingsRoot
      >
        <button
          type="button"
          class="header__nav__profile-button"
          (mouseenter)="openDesktopSettingsDropdown()"
          (mouseleave)="scheduleDesktopSettingsDropdownClose()"
        >
          <img
            class="icon"
            src="../../../../../assets/img/gear.svg"
            alt="gear icon"
          />
        </button>

        <div
          class="header__settings-dropdown"
          *ngIf="desktopSettingsDropdownOpened"
          (mouseenter)="cancelDesktopSettingsDropdownClose()"
          (mouseleave)="scheduleDesktopSettingsDropdownClose()"
        >
          <div class="header__settings-dropdown__content">
            <div
              aria-label="Settings menu"
              class="header__settings-dropdown__tabs"
            >
              <button
                *ngFor="let tab of getDesktopSettingsTabsForRender()"
                type="button"
                class="header__settings-dropdown__tab"
                [class.header__settings-dropdown__tab_active]="
                  isDesktopProfileTabActive(tab)
                "
                (click)="onDesktopProfileTabClick(tab)"
                (keydown.enter)="onDesktopProfileTabClick(tab)"
              >
                <span class="chip-content">
                  <span
                    class="chip-dot"
                    *ngIf="isDesktopProfileTabActive(tab)"
                  ></span>
                  {{ tab.text! | translate }}
                </span>
              </button>
            </div>

            <button
              mat-button
              type="button"
              class="header__settings-dropdown__logout-button"
              (click)="onLogout()"
            >
              {{ "logOut" | translate }}
            </button>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>
</div>
<div *ngIf="isMobileHeader" class="header-mobile">
  <div #mobileHeader class="header-mobile__header">
    <div class="header__credits" *ngIf="user">
      <a [routerLink]="'/home'">
        <div class="ling-credits-logo"></div>
      </a>
      <a *ngIf="!isPreviewPage"
         [routerLink]="'/profile/credits'">
        <span class="header__credits__amount">{{ credits }} </span>
        <span class="header__credits__text">
          {{ handlePluralTranslation(credits, "creditName") | translate }}
        </span>
      </a>
    </div>
    <a [routerLink]="'/home'" class="mobile-logo" *ngIf="!user">
      <img class="mobile-logo" src="assets/img/logo-text.svg" alt="Lingon" />
    </a>
    <button
      *ngIf="!isPreviewPage"
      type="button"
      (click)="toggleDropdown()"
      class="header-mobile__header__burger-button"
      [class.header-mobile__header__burger-button_opened]="mobileDropdownOpened"
    >
      <div class="header-mobile__header__burger-button__line"></div>
      <div class="header-mobile__header__burger-button__line"></div>
    </button>
  </div>
  <div
    class="header-mobile__under-layer"
    [class.header-mobile__under-layer_opened]="mobileDropdownOpened"
  ></div>
  <div
    #mobileDropdown
    class="header-mobile__dropdown"
    [class.header-mobile__dropdown_opened]="mobileDropdownOpened"
  >
    <ul class="header__nav">
      <ng-container *ngIf="user; else login">
        <li
          *ngFor="let item of headerMenuItems"
          class="header__nav__item"
          [class.header__nav__item_active]="isMenuItemActive(item)"
        >
          <a
            [routerLink]="item.linkRoute"
            [class.header__nav__profile-button]="item.icon"
            (click)="toggleDropdown(false)"
          >
            <span *ngIf="!item.icon">
              {{ item.text! | translate }}
            </span>
            <img
              *ngIf="item.icon"
              class="icon"
              src="../../../../../assets/img/gear.svg"
              alt="gear icon"
            />
          </a>
        </li>
        <button
          class="mobile-logout"
          mat-flat-button
          [color]="'primary'"
          (click)="onLogout()"
          *ngIf="user"
          type="button"
        >
          {{ "logOut" | translate }}
        </button>
      </ng-container>
    </ul>
  </div>
</div>
<ng-template #login>
  <a
    [routerLink]="'/start'"
    mat-flat-button
    color="primary"
    (click)="toggleDropdown(false)"
    >{{ "header.getStarted" | translate }}</a
  >
  <a
    [routerLink]="(isOnLoginPage$ | async) ? null : '/login'"
    [queryParams]="{ next: nextRouteAfterLogin$ | async }"
    queryParamsHandling="merge"
    mat-stroked-button
    color="primary"
    (click)="toggleDropdown(false)"
    >{{ "header.login" | translate }}</a
  >
</ng-template>
